import styled from '@emotion/styled'

import { columnWidth, mediaColumns, Grid } from '@/styles/grid'
import { mediaDown, mediaUp } from '@/styles/media'
import { transitions } from '@/styles/theme'

export const GridWrapper = styled(Grid)`
  position: relative;
  contain: layout;
`

export const Wrapper = styled.div`
  margin: 40px 0 60px;
  contain: layout;

  ${mediaUp('lg')} {
    margin: 80px 0 120px;
  }
`

export const Container = styled.div`
  overflow: hidden;
  width: 100%;
  margin-bottom: -25px;
  margin-top: -25px;
  contain: layout;

  .swiper {
    ${mediaColumns({ xs: [12, 0] })};
    width: 100%;
    overflow: visible;
    padding: 25px 0 25px;
    contain: layout;
  }

  .swiper-slide {
    &:last-child {
      margin-inline-end: 0;
    }

    ${mediaDown('md')} {
      ${columnWidth(10, 'width: ')};
      max-width: 288px;
    }

    ${mediaUp('md')} {
      ${columnWidth(5, 'width: ')};
      max-width: 288px;
    }

    ${mediaUp('lg')} {
      max-width: 510px;
    }

    ${mediaUp(1920)} {
      ${columnWidth(4, 'width: ')};
    }

    ${mediaUp(2230)} {
      ${columnWidth(3, 'width: ')};
    }
  }
`

export const Buttons = styled.div`
  ${mediaColumns({ xs: [12, 0] })};
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaUp('md')} {
    justify-content: flex-end;
  }
`

export const ButtonNext = styled.div`
  will-change: transform;
  transform: translateZ(0);
`

export const ButtonPrev = styled.div`
  will-change: transform;
  transform: translateZ(0);
`

export const TitleWrapper = styled.div`
  ${mediaColumns({ xs: [12, 0], md: [10, 1] })};
  contain: content;
  margin-bottom: 30px;
  will-change: contents;

  ${mediaDown('md')} {
    margin-bottom: 18px;
  }
`

export const ButtonsHover = styled.div`
  ${mediaColumns({ xs: [12, 0] })};
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 10000;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  transform: translate3d(0, -50%, 0);
  pointer-events: none;
  opacity: 0;
  transition: opacity ${transitions.base};
  will-change: opacity;

  ${GridWrapper}:hover & {
    opacity: 1;
  }

  button.discover-button-next {
    margin-inline-end: 39px;

    ${mediaUp('lg')} {
      margin-inline-end: 68px;
    }
  }

  button.discover-button-prev {
    margin-inline-start: 39px;

    ${mediaUp('lg')} {
      margin-inline-start: 68px;
    }
  }

  ${mediaDown('md')} {
    display: none;
  }

  html[lang^='ar'] & {
    direction: ltr;
  }
`

export const SkeletonContainer = styled.div`
  width: 100%;
  height: 400px;
  background: linear-gradient(
    90deg,
    rgba(240, 240, 240, 0.1) 0%,
    rgba(240, 240, 240, 0.5) 50%,
    rgba(240, 240, 240, 0.1) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  margin-top: 20px;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

export const FirstParkingContainer = styled.div`
  ${mediaColumns({ xs: [12, 0], md: [10, 1] })};
  margin-bottom: 20px;
  display: block;
  will-change: contents;
  contain: layout paint;
  content-visibility: auto;

  ${mediaUp('md')} {
    margin-bottom: 30px;
  }
`
